import { render, staticRenderFns } from "./shift-auth-accept.vue?vue&type=template&id=6e54a4b4&"
import script from "./shift-auth-accept.vue?vue&type=script&lang=js&"
export * from "./shift-auth-accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports